import { render } from "./FilterIssuesHistory.vue?vue&type=template&id=3381b146&scoped=true"
import script from "./FilterIssuesHistory.vue?vue&type=script&lang=js"
export * from "./FilterIssuesHistory.vue?vue&type=script&lang=js"

import "./FilterIssuesHistory.vue?vue&type=style&index=0&id=3381b146&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3381b146"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField,QIcon});
